import { BannerTypes, PredefinedBanner } from 'components/page-flag/types'
import { keyFromSelector } from 'i18next'

export const PredefinedBanners: Record<BannerTypes | string, PredefinedBanner> = {
  [BannerTypes.MIDDLE_EAST_ENERGY_CRISIS]: {
    type: 'light',
    titleKey: keyFromSelector(($) => $.middleEastCrisisBanner.title),
    descriptionKey: keyFromSelector(($) => $.middleEastCrisisBanner.description),
    singleLine: true,
    noOnClick: true,
    size: 'small'
  },

  [BannerTypes.SCHEDULED_DOWNTIME]: {
    type: 'attention',
    titleKey: keyFromSelector(($) => $.scheduledDowntime.title),
    descriptionKey: keyFromSelector(($) => $.scheduledDowntime.description)
  },

  [BannerTypes.SIMULATION_DOWN]: {
    type: 'attention',
    titleKey: keyFromSelector(($) => $.simulationDown.title),
    descriptionKey: keyFromSelector(($) => $.simulationDown.apologies)
  }
}
